import { useNavigate } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarPerson, F0Icon } from '@factorialco/f0-react'
import { AlertCircleLine } from '@factorialco/f0-react/icons/app'
import { Envelope, Link, Phone } from '@factorialco/f0-react/icons/app'
import { DuplicateCandidateFieldsFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { warningLabel } from './index.vanilla.css'

export type CandidateCardCandidate = Pick<
  DuplicateCandidateFieldsFragment,
  'id' | 'firstName' | 'lastName' | 'fullName' | 'email' | 'phoneNumber' | 'personalUrl'
>

interface CandidateCardProps {
  candidate: CandidateCardCandidate
  jobPostingTitle?: string | null
  matchedFieldsText?: string
  applicationId?: number
  jobPostingId?: number
}

export const CandidateCard = ({
  candidate,
  jobPostingTitle,
  matchedFieldsText,
  applicationId,
  jobPostingId,
}: CandidateCardProps) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const isClickable = Boolean(applicationId && jobPostingId)
  const handleClick = () => {
    if (!isClickable || !applicationId || !jobPostingId) {
      return
    }

    navigate(
      navigation.ats.jobs.jobsId.applications.applicationDetail.fullPath({
        jobId: jobPostingId,
        application_id: applicationId,
      })
    )
  }

  return (
    <>
      {matchedFieldsText && (
        <Box flexDirection="row" gap="s4" alignItems="center">
          <F0Icon icon={AlertCircleLine} size="md" color="warning" />
          <Text.Normal size="100" className={warningLabel}>
            {i18n.t('ats.candidate_details.duplicated.details.body.fields.title')}{' '}
            {matchedFieldsText}
          </Text.Normal>
        </Box>
      )}

      <Box
        gap="s12"
        padding="s16"
        borderRadius={{ all: 'abs016' }}
        border={{ all: { style: 'solid', width: 's1', color: 'grey200' } }}
        cursor={isClickable ? 'pointer' : 'default'}
        onClick={isClickable ? handleClick : undefined}
      >
        <Box flexDirection="row" gap="s12" alignItems="center">
          <F0AvatarPerson
            firstName={candidate.firstName}
            lastName={candidate.lastName}
            size="medium"
          />
          <Text.Normal weight="medium" color="textPrimary">
            {candidate.fullName}
          </Text.Normal>
          {jobPostingTitle && <Text.Normal color="textSecondary">{jobPostingTitle}</Text.Normal>}
        </Box>

        <Box gap="s4">
          {candidate.email && (
            <Box flexDirection="row" gap="s4" alignItems="center">
              <F0Icon icon={Envelope} size="sm" color="secondary" />
              <Text.Normal color="textSecondary">{candidate.email}</Text.Normal>
            </Box>
          )}

          {candidate.phoneNumber && (
            <Box flexDirection="row" gap="s4" alignItems="center">
              <F0Icon icon={Phone} size="sm" color="secondary" />
              <Text.Normal color="textSecondary">{candidate.phoneNumber}</Text.Normal>
            </Box>
          )}

          {candidate.personalUrl && (
            <Box flexDirection="row" gap="s4" alignItems="center">
              <F0Icon icon={Link} size="sm" color="secondary" />
              <Text.Normal color="textSecondary">{candidate.personalUrl}</Text.Normal>
            </Box>
          )}
        </Box>
      </Box>
    </>
  )
}
